// extracted by mini-css-extract-plugin
export var attachmentContainer = "_go-0";
export var fileList = "_go-2";
export var removeFileButton = "_go-1";